/** Minimal Sentry scope surface used to attach user + tenant without pulling in SDK types. */
export interface SentryUserContextScope {
  setUser(user: { id: string } | null): void;
  setTag(key: string, value: string | undefined): void;
  setContext(name: string, context: Record<string, unknown> | null): void;
}

/**
 * Attach opaque user id and church tenant to the active Sentry scope.
 * Pass null/undefined userId to clear user, church tag, and church context (logout).
 */
export function setSentryUserContext(
  scope: SentryUserContextScope,
  userId: string | null | undefined,
  churchId: string | null | undefined,
): void {
  if (!userId) {
    scope.setUser(null);
    scope.setContext("church", null);
    scope.setTag("churchId", undefined);
    return;
  }
  scope.setUser({ id: userId });
  if (churchId) {
    scope.setTag("churchId", churchId);
    scope.setContext("church", { id: churchId });
  } else {
    scope.setContext("church", null);
    scope.setTag("churchId", undefined);
  }
}
